/** @jsx jsx */
import { jsx, Box, Container, Heading, Text, Image } from "theme-ui";
import Tabs, { TabPane } from "rc-tabs";
import { rgba } from "polished";
import fire from "assets/images/simpsons/fire.png";
import clean from "assets/images/simpsons/lisa.png";
import homer from "assets/images/simpsons/homer.jpg";
import money from "assets/images/simpsons/money.jpeg";
const data = [
  {
    id: 1,
    tabTitle: "For a safer city",
    title: `Eliminate fire hazards in time`,
    description: `85% of outdoor fires are caused by human mindlessness. Smoking materials such as cigarette butts can smolder undetected for up to 40 minutes before bursting into flames. By detecting potential fire hazards before it is too late, garbage can fires will be a thing of the past.`,
    image: fire,
  },
  {
    id: 2,
    tabTitle: "For a cleaner city",
    title: `Minimize littering`,
    description: `The public garbage collection systems in big cities are becoming increasingly complex. New York City has 23,000 garbage cans, spending almost $800 million a year on trash and recycling collection. Still, public bins in inner cities are often jammed, priming pedestrians to litter. By detecting full bins before they are jammed, we allow for fast and efficient trash collection. This minimizes the periods in which bins are unusable and any consequent littering.`,
    image: clean,
  },
  {
    id: 3,
    tabTitle: "Why choose iCleen",
    title: `Smart, Scalable, Sustainable`,
    description: `Our solution is step towards a more sustainable system – both economically and ecologically. We bring low-energy sensors, state-of-the-art analytics and an intuitive interface to the recycling industry. Our solution is compatible with all public bins, minimizing any fix costs and maximizing scalability. Simply equip a bin with our solution and connect it to our network with just the press of a button.`,
    image: homer,
  },
  {
    id: 4,
    tabTitle: "Our business promise",
    title: `Make the best out of your ressources`,
    description: `By monitoring the fullness of bins through the city, we minimize any resources required to check on bins. Through intelligent data analytics, we dynamically find the optimal trash collection routing for you. As this reduces littering, our solution further cuts the immense cost of street cleaning.`,
    image: money,
  },
];

const WhyUs = () => {
  return (
    <Box as="section" id="why-us" sx={styles.section}>
      <Container>
        <Tabs sx={styles.tabs} animated={{ tabPane: true }}>
          {data?.map((item) => (
            <TabPane
              key={item.id}
              tab={<Heading as="h4">{item.tabTitle}</Heading>}
            >
              <Box>
                <Heading>{item.title}</Heading>
                <Text as="p" sx={styles.description}>
                  {item.description}
                </Text>
              </Box>
              <Box sx={styles.illustration}>
                <Image src={item.image} alt="illustration" />
              </Box>
            </TabPane>
          ))}
        </Tabs>
      </Container>
    </Box>
  );
};

export default WhyUs;

const styles = {
  section: {
    pt: [11, null, null, 12],
    pb: [8, null, null, 9, null, 11],
  },
  tabs: {
    border: 0,
    ".rc-tabs-nav": {
      mb: [8, null, null, 9, 10, 9, 12],
    },
    ".rc-tabs-nav-wrap": {
      borderBottom: `1px solid ${rgba("#01070D", 0.1)}`,
      justifyContent: "center",
    },
    ".rc-tabs-nav-list": {
      flexGrow: 1,
      justifyContent: "space-evenly",
      pb: [3, null, null, 5, null, 6],
    },
    ".rc-tabs-tab-btn": {
      outline: 0,
      alignItems: "center",
      img: {
        outline: 0,
      },
    },
    ".rc-tabs-tab": {
      backgroundColor: "transparent",
      // m: ['0 45px'],
      h4: {
        fontFamily: "body",
        fontSize: [0, null, null, 17, null, null, 4],
        fontWeight: 700,
        lineHeight: 1.5,
        textAlign: ["center", null, null, null, "left"],
        whiteSpace: ["break-spaces", null, null, null, "unset"],
      },
    },
    ".rc-tabs-tabpane": {
      display: ["flex", null, null, "grid"],
      flexDirection: ["column-reverse", null, null, "unset"],
      alignItems: "center",
      justifyContent: "center",
      gridTemplateColumns: [null, null, null, "0.9fr 1.1fr"],
      outline: 0,
      gap: [5, null, null, 11],
      h2: {
        color: "heading",
        fontSize: [24, null, null, 6, 26, 8, 40],
        fontWeight: 700,
        lineHeight: [1.45, null, null, 1.5],
        letterSpacing: [null, null, null, "0.5px", null, "-1px"],
        textAlign: ["center", null, null, "left"],
      },
      p: {
        color: "textSecondary",
        fontSize: [1, null, null, 2, 17],
        lineHeight: [1.87, null, null, 2, 2.48],
        textAlign: ["center", null, null, "left"],
        mt: [4],
      },
      ".list-item": {
        fontSize: [0, null, null, 1, 2],
        fontWeight: 500,
        lineHeight: [2.8],
        display: "flex",
        alignItems: "center",
      },
    },
  },
  list: {
    mt: [5],
    display: "grid",
    justifyContent: ["center", null, null, "unset"],
    gridTemplateColumns: ["repeat(2, 164px)", null, null, "repeat(2, 180px)"],
  },
  learnMore: {
    mt: [4],
    textAlign: ["center", null, null, "left"],
    a: {
      fontSize: [null, null, null, 1, 2],
    },
  },
  illustration: {
    display: ["flex"],
    alignItems: "center",
    justifyContent: "center",
    textAlign: [null, null, null, null, null, "center"],
    img: {
      maxWidth: ["65%", null, null, "100%", null, "90%", "100%"],
      maxHeight: "600px",
    },
  },
};
